import { Box } from '@chakra-ui/react';
import { DateRangePicker } from '@/components/ui';

interface DateRangeInputsProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  disabled?: boolean;
}

export function DateRangeInputs({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled = false,
}: DateRangeInputsProps) {
  return (
    <Box mt={{ base: '4', md: '0' }} mb={{ base: '4', md: '4' }}>
      <DateRangePicker
        value={{ start: startDate || null, end: endDate || null }}
        onChange={(range) => {
          onStartDateChange(range.start || '');
          onEndDateChange(range.end || '');
        }}
        minDate={new Date()}
        startPlaceholder="Start Date"
        endPlaceholder="End Date"
        disabled={disabled}
      />
    </Box>
  );
}
